export class WorkflowsRightsUsersForm {
  users: WorkflowsRightsUsersFormUsers[];
}

export class WorkflowsRightsUsersFormUsers {
  appUserId: number;
  externalUserId: string;
}
